<template>
  <div class="inputFormStyle">
    <v-container fluid class="pa-0">
      <v-row v-if="heading" no-gutters>
        <v-col>
          <span class="headingStyle primary--text">{{ $t(heading) }} </span>
        </v-col>
        <slot name="appendTitle"></slot>
      </v-row>
      <slot name="prependBody"></slot>
      <v-row
        :style="'max-height:' + rowHeight"
        class="my-4"
        v-bind:class="{
          'align-center': !rec.textPositionStart,
          'align-start': rec.textPositionStart
        }"
        v-for="(rec, index) in detail"
        :key="index"
        no-gutters
      >
        <v-col :cols="titleCols">
          {{ $t(rec.text) }}
          <RequiredLabel v-if="rec.required ? true : false" />
        </v-col>
        <v-col :cols="rec.cols ? rec.cols : contentsCols">
          <slot :name="rec.name" v-bind:item="dataList">
            <span v-if="rec.component === 'text'">
              {{ $t(dataList[rec.name]) }}
            </span>
            <span v-if="rec.component === 'label'">
              {{ $t(dataList[rec.name].label) }}
            </span>

            <component
              v-else-if="
                rec.name === 'orderStatus' || rec.name === 'saleStatus'
              "
              :is="rec.component"
              v-model="dataList[rec.name]"
              :type="rec.type"
              @changeValue="changeOrderStatus"
            />
            <component
              v-else-if="
                rec.component === 'SelectStatusOrder' ||
                rec.component === 'SelectStatusSale'
              "
              :is="rec.component"
              v-model="dataList[rec.name]"
              :type="rec.type"
            />

            <component
              v-else-if="rec.component === 'SelectRegion'"
              :is="rec.component"
              v-model="dataList[rec.name]"
              :country="dataList['country']"
            />
            <component
              v-else-if="
                rec.component === 'SelectStatusForLedgerSheet' && rec.type
              "
              :is="rec.component"
              v-model="dataList[rec.name]"
              :type="rec.type"
            />
            <span v-else-if="rec.component === 'Remarks'">
              <Remarks
                v-model="dataList[rec.name].data"
                :title="dataList[rec.name].title"
                :text="dataList[rec.name].text"
              />
            </span>
            <span v-else-if="rec.component === 'SelectStorageName'">
              <SelectStorageName
                :is="rec.component"
                v-model="dataList[rec.name]"
                :hasDefault="'hasDefault' in rec ? rec.hasDefault : true"
                :isHideUnusedStorage="isHideUnusedStorage"
              />
            </span>

            <span v-else-if="rec.component === 'SelectSortNumber'">
              <SelectSortNumber
                v-model="dataList[rec.name]"
                :master-data="sortNumberList"
              />
            </span>

            <span v-else-if="rec.component === 'CheckEnabled'">
              <v-checkbox
                v-model="dataList[rec.name]"
                :label="$t('product.product_indicate')"
              ></v-checkbox>
            </span>

            <span v-else-if="rec.component === 'CheckAutoShip'">
              <v-checkbox
                v-model="dataList[rec.name]"
                :label="$t('nextengine.nextengine_auto-ship-enabled')"
              ></v-checkbox>
            </span>

            <component
              v-else-if="'component' in rec"
              :class="{ [rec.component]: true }"
              :is="rec.component"
              v-model="dataList[rec.name]"
            />

            <v-text-field
              v-else
              v-model="dataList[rec.name]"
              :placeholder="
                'placeholder' in rec
                  ? $t(rec.placeholder)
                  : $t('common.input_input_1')
              "
              outlined
              dense
              hide-details
              :height="inputItemHeight"
            >
            </v-text-field>
          </slot>
        </v-col>
        <!-- 補足がある場合 -->
        <v-col cols="12" v-if="rec.description" class="description">
          {{ $t(rec.description) }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RequiredLabel from '@/components/items/Labels/RequiredLabel'

import PhoneNumberInput from '@/components/items/inputs/PhoneNumberInput'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import FromToDatePicker from '@/components/items/inputs/FromToDatePicker'
import Remarks from '@/components/items/Designs/Remarks'

import {
  SelectCreateUser,
  SelectCreateUserClearable,
  SelectCurrency,
  SelectCustomerName,
  SelectCustomerNameForNextengine,
  SelectProductCategory,
  SelectSuggestedReceivingLocation,
  SelectStatusOrder,
  SelectStatusSale,
  SelectSupplierName,
  SelectStorageName,
  SelectCountry,
  SelectCustomerCategory,
  SelectRegion,
  SelectStockAdjustReason,
  SelectStatusStockAdjust,
  SelectStatusRefund,
  SelectStockMoveReason,
  SelectStatusStockMove,
  SelectStatusForLedgerSheet,
  SelectStatusShip,
  SelectPlatform,
  SelectPlatformECName,
  SelectSortNumber,
  SelectIncompleteOrderReason,
  MultipleSelectCustomerName,
  MultipleSelectSupplierName,
  MultipleSelectProductName
} from '@/components/items/Selectboxes'

import {
  SearchCustomerNameAndCurrency,
  SearchMultipleCustomerNameAndCurrency,
  SearchOrderInfo,
  SearchProductNoAndProductCategory,
  SearchSaleInfo,
  SearchECSaleInfo,
  SearchRefundInfo,
  SearchCurrency,
  SearchSupplierNameAndCurrency,
  SearchMultipleSupplierNameAndCurrency,
  SearchCustomerName,
  SearchMultipleCustomerName,
  SearchSupplierName,
  SearchMultipleSupplierName,
  SearchTwinTextboxInfo,
  SearchShipAndLoadingStorage,
  SearchProductName,
  SearchAmountRange
} from '@/components/layouts/Search'

import NameTextBoxArea from '@/components/items/Designs/NameTextBoxArea'

export default {
  components: {
    RequiredLabel,

    PhoneNumberInput,
    NormalDatePicker,
    FromToDatePicker,
    Remarks,

    SelectStatusOrder,
    SelectStatusSale,
    SelectCreateUser,
    SelectCreateUserClearable,

    SelectCurrency,
    SelectProductCategory,
    SelectCustomerName,
    SelectCustomerNameForNextengine,
    SelectSuggestedReceivingLocation,
    SelectSupplierName,
    SelectStorageName,
    SelectCountry,
    SelectCustomerCategory,
    SelectRegion,
    SelectStockAdjustReason,
    SelectStatusStockAdjust,
    SelectStatusRefund,
    SelectStockMoveReason,
    SelectStatusStockMove,
    SelectStatusForLedgerSheet,
    SelectStatusShip,
    SelectPlatform,
    SelectPlatformECName,
    SelectSortNumber,
    SelectIncompleteOrderReason,

    SearchCustomerNameAndCurrency,
    SearchMultipleCustomerNameAndCurrency,
    SearchOrderInfo,
    SearchProductNoAndProductCategory,
    SearchSaleInfo,
    SearchECSaleInfo,
    SearchRefundInfo,
    SearchCurrency,
    SearchSupplierNameAndCurrency,
    SearchMultipleSupplierNameAndCurrency,
    SearchCustomerName,
    SearchMultipleCustomerName,
    SearchSupplierName,
    SearchMultipleSupplierName,
    SearchTwinTextboxInfo,
    SearchShipAndLoadingStorage,
    SearchProductName,
    SearchAmountRange,

    NameTextBoxArea,
    MultipleSelectCustomerName,
    MultipleSelectSupplierName,
    MultipleSelectProductName
  },
  props: {
    heading: {
      type: String,
      require: false,
      default: ''
    },
    detail: {
      type: Array,
      require: true,
      default: () => []
    },
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    rowHeight: {
      type: String,
      require: false,
      default: '100%'
    },
    inputItemHeight: {
      type: String,
      require: false,
      default: ''
    },
    titleCols: {
      type: Number,
      require: false,
      default: 6
    },
    contentsCols: {
      type: Number,
      require: false,
      default: 6
    },
    masterData: {
      Type: Array,
      default: () => []
    },
    isHideUnusedStorage: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ items: [] }),
  created() {
    this.items = this.getCountryCode()
  },
  methods: {
    getCountryCode() {
      // TODO 本当は共通method
      return [
        { label: '+81', value: 1 }
        // { label: 'それ以外', value: 99 }
      ]
    },
    changeOrderStatus(value) {
      if (value && value.value === 99) {
        this.$emit('offSearchHeaderInfoInvalidData')
      }
    }
  },
  computed: {
    dataList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    sortNumberList() {
      return this.masterData.map((data) => {
        return data.sortNumber
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.inputFormStyle {
  width: 100%;
  height: 100%;
  font-size: 14px;
}
.headingStyle {
  font-size: 16px;
  font-weight: bold;
}
.description {
  font-size: 12px;
  margin-top: 4px;
}
.master-list-search .row {
  width: 50%;
  max-width: 50%;
  padding: 0px 30px;
}
.master-list-search .col:first-of-type {
  padding-right: 10px;
  max-width: 20%;
}
.master-list-search .container {
  display: flex;
  flex-wrap: wrap;
}
.master-list-search .container .my-4 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.master-list-search .container .my-4:first-of-type {
  margin-top: 16px !important;
}
.master-list-search .container .my-4:last-of-type {
  margin-bottom: 16px !important;
}
</style>
